import apiClient from "../lib/api/client";

export interface MaterialityPlanItem {
  materiality_plan_id: number;
  materiality_id: number;
  materiality_name: string;
  is_main: boolean;
}

export interface PlanCategory {
  category_id: number;
  category_code: string;
  items: MaterialityPlanItem[];
}

export interface PlanMonth {
  month: number;
  categories: PlanCategory[];
}

export interface PlanYear {
  year: number;
  months: PlanMonth[];
}

export interface MaterialityPlanningData {
  schema_version: number;
  years: PlanYear[];
}

export interface CreatePlanBody {
  materiality_id: number;
  category_id: number;
  month: number;
  year: number;
  is_main: boolean;
}

export type UpdatePlanBody = CreatePlanBody;

function unwrapData(raw: unknown): Record<string, unknown> {
  if (!raw || typeof raw !== "object") return {};
  const r = raw as Record<string, unknown>;
  const inner = r.data;
  if (inner && typeof inner === "object" && !Array.isArray(inner)) {
    return inner as Record<string, unknown>;
  }
  return r;
}

export const materialityPlanningService = {
  async get(): Promise<MaterialityPlanningData> {
    const response = await apiClient.get<unknown>("/materiality-planning");
    const payload = unwrapData(response);
    return {
      schema_version: Number(payload.schema_version ?? 1),
      years: Array.isArray(payload.years) ? (payload.years as PlanYear[]) : [],
    };
  },

  async create(body: CreatePlanBody): Promise<{ materiality_plan_id: number }> {
    const response = await apiClient.post<unknown>("/materiality-planning", body);
    const payload = unwrapData(response);
    return {
      materiality_plan_id: Number(
        payload.materiality_plan_id ?? payload.id ?? 0,
      ),
    };
  },

  async update(id: number, body: UpdatePlanBody): Promise<void> {
    await apiClient.put<unknown>(`/materiality-planning/${id}`, body);
  },

  async remove(id: number): Promise<void> {
    await apiClient.delete(`/materiality-planning/${id}`);
  },
};

export default materialityPlanningService;
